export default __webpack_public_path__ + "static/media/arrow-hp-next.7a26197f.png";